module.exports = __webpack_public_path__ + "img/photo-0064.913f51b1.jpg";